import { StoreFactories } from "@com.mgmtp.a12.client/client-core/lib/core/store";
import { WorkflowsActions } from "@com.mgmtp.a12.workflows/workflows-core/lib/actions";
import { ApplicationActions } from "@com.mgmtp.a12.client/client-core/lib/core/application";

export const taskAssignmentDoneMiddleware = StoreFactories.createMiddleware((api, next, action) => {
	const result = next(action);
	if (WorkflowsActions.assignTask.done.match(action) || WorkflowsActions.assignTask.failed.match(action)) {
		api.dispatch(ApplicationActions.setBusy(false));
	}
	return result;
});
